import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationState, ThunkApi } from ".";

const sliceName = "coordinatesSlice";

// -----------------
// STATE - This defines the type of data maintained in this Redux slice.
export interface CoordinatesState {
	coordinates: string;
	justCopied: boolean;
	showCoordinates: boolean;
	timer?: number;
}

const initialState: CoordinatesState = {
	coordinates: "",
	justCopied: false,
	showCoordinates: false,
};

let timer: number;

export const copyCoordinates = createAsyncThunk<void, string, ThunkApi>(
	`${sliceName}/copyCoordinates`,
	async (coordinates) => {
		return new Promise((resolve, reject) => {
			navigator.clipboard.writeText(coordinates).catch(() => {
				console.error("Writing to clipboard disallowed");
				reject();
			});
			if (timer) {
				window.clearTimeout(timer);
			}
			timer = window.setTimeout(() => resolve(), 1000);
		});
	}
);

const slice = createSlice({
	name: sliceName,
	initialState,
	reducers: {
		setCoordinates: (state, { payload }: PayloadAction<string>) => {
			state.coordinates = payload;
			state.showCoordinates = true;
		},
		showCoordinates: (state) => {
			state.showCoordinates = true;
		},
		hideCoordinates: (state) => {
			state.showCoordinates = false;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(copyCoordinates.pending, (state) => {
				state.justCopied = true;
			})
			.addCase(copyCoordinates.fulfilled, (state) => {
				state.justCopied = false;
			})
			.addCase(copyCoordinates.rejected, (state) => {
				state.justCopied = false;
			})
	}
});

// ----------------
// exports
export const selector = (state: ApplicationState): CoordinatesState => state.coordinatesState;
export const actions = {
	...slice.actions,
};
export const reducer = slice.reducer;
